import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('a-col', {
    staticClass: "pt-30",
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('h4', {
    staticClass: "flex-box"
  }, [_c('span', {
    staticClass: "flex-item"
  }, [_vm._v(_vm._s(_vm.t('客户代码')) + _vm._s(_vm.tc('：')) + " " + _vm._s(_vm.$store.state.user.customerInfo.customer_code))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-permission": "welcome_sign_up_add_sign_body",
      "id": "welcome_sign_up_add_sign_body",
      "fbu-analyse-name": $t("\u6DFB\u52A0\u4E3B\u4F53")
    },
    on: {
      "click": _vm.handleAddFirm
    }
  }, [_vm._v(_vm._s(_vm.t('添加主体')))])], 1), _c('a-skeleton', {
    attrs: {
      "loading": _vm.startupInfoLoading,
      "active": ""
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "columns": _vm.columns,
      "data-source": _vm.tabeData,
      "row-key": "sign_body_contract_id"
    }
  })], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };